import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from '../nest-api';

@Injectable()
export class FileAttachmentProvider {

  private _service: string = 'loan';
  private _model: string = 'file-attachment';
  constructor(
    private nestApiProvider: NestApiProvider
  ) {
  }
  public getList(empId?: string): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'list';
    const _params: any = {};
    const _urlParams: any = { empId, limit: 1000 };
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/file-attachment/file-attachment-provider.ts